import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * 契約情報取得API
 * @param  {} params={}
 */
export const getContract = (params = {}) => {
  const defaults = {
    _path: 'AG/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 契約情報変更API
 * @param  {} params={}
 */
export const updateContract = (params = {}) => {
  const defaults = {
    _path: 'AG/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 利用者取得API
 * @param  {} params={}
 */
export const getUsers = (params = {}) => {
  const defaults = {
    _path: 'AG/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 利用者追加API
 * @param  {} params={}
 */
export const addUser = (params = {}) => {
  const defaults = {
    _path: 'AG/004',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 利用者更新API
 * @param  {} params={}
 */
export const updateUser = (params = {}) => {
  const defaults = {
    _path: 'AG/005',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 利用者状態更新
 * @param  {} params={}
 */
export const updateUserStatus = (params = {}) => {
  const defaults = {
    _path: 'AG/012',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 利用者一括更新
 * @param  {} params={}
 */
export const updateUsersInBulk = (params = {}) => {
  const defaults = {
    _path: 'AG/006',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 利用者リセットAPI
 * @param  {} params={}
 */
export const resetUser = (params = {}) => {
  const defaults = {
    _path: 'AG/007',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * パッケージ・商品情報取得
 * @param  {} params={}
 */
export const listPackagesAndProducts = (params = {}) => {
  const defaults = {
    _path: 'AG/008',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 商品申込API
 * @param  {} params={}
 */
export const applyProducts = (params = {}) => {
  const defaults = {
    _path: 'AG/009',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 申込履歴一覧API
 * @param  {} params={}
 */
export const listApplicationHistory = (params = {}) => {
  const defaults = {
    _path: 'AG/010',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 契約ライセンス情報取得API
 * @param  {} params={}
 */
export const getContractLicenses = (params = {}) => {
  const defaults = {
    _path: 'AG/011',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 利用アカウントCSVダウンロード
 * @param  {} params={}
 */
export const getAccountCSV = (params = {}) => {
  const defaults = {
    _path: 'AG/013',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r, { responseType: 'blob' })
}

/**
 * 利用アカウントCSVアップロード
 * @param  {} params={}
 */
export const updateAccountCSV = (file, { id, name, email }) => {
  const r = new FormData()
  r.append('_path', 'AG/014')
  r.append('token', store.state.auth.token)
  r.append('file', file)
  r.append('user_id', id)
  r.append('admin_name', name)
  r.append('admin_email', email)
  r.append('contract_file_upload', true)

  const options = {
    'content-type': 'multipart/form-data'
  }

  return axios.post(API_RELAY_PATH, r, options)
}

/**
 * 商品価格取得
 * @param {Object} params
 * @param {number} params.productId 商品ID
 * @param {number} params.numOfLicenses ライセンス数
 */
export const getProductPrice = ({ productId, numOfLicenses }) => {
  const defaults = {
    _path: 'AG/015',
    token: store.state.auth.token
  }

  const r = {
    ...defaults,
    product_id: productId,
    num_of_licenses: numOfLicenses
  }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * WEBセッション情報取得API
 * @param  {} params={}
 */
export const getWebSession = (params = {}) => {
  const defaults = {
    _path: 'CM/008',
    token: store.state.auth.token
  }

  // 開発環境の場合は、パラメータにmember_paramをベタ書きで付与する
  if (process.env.NODE_ENV === 'development') {
    params.member_param = process.env.VUE_APP_SNH_WEB_MEMBER_PARAM
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 申込認証コード取得API
 * @param  {} params={}
 */
export const getOfferCode = (params = {}) => {
  const defaults = {
    _path: 'SN/011',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * WEB会員認証API
 * @param  {} params={}
 */
export const authWebUser = (params = {}) => {
  const defaults = {
    _path: 'SN/008',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
